











import Vue from 'vue';
import pazienteEdit from '@/components/commands/PazienteEdit.vue';

export default Vue.extend({
    components: { pazienteEdit },
    methods: {
        close() {
            this.$router.push({
                name: 'PazienteList',
            });
        },
    },
});
